<script>
import appConfig from "@/app.config";
import {pagingModel} from "@/models/pagingModel";
import {required} from "vuelidate/lib/validators";
import {vanBanDenModel} from "@/models/vanBanDenModel";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import Treeselect from '@riophae/vue-treeselect'
import vue2Dropzone from "vue2-dropzone";
import {butPheModel} from "@/models/butPheModel";
import {phanCongModel} from "@/models/phanCongModel";
import {notifyModel} from "@/models/notifyModel";
import Swal from "sweetalert2";
import {trangThaiModel} from "@/models/trangThaiModel";
import {CURRENT_USER} from "@/helpers/currentUser";
import {CONSTANTS} from "@/helpers/constants";
import LetterCube from "../../components/LetterCube.vue";

export default {
  page: {
    title: "Văn bản đến",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    Multiselect,
    'ckeditor-nuxt': () => {
      return import('@blowstack/ckeditor-nuxt')
    },
    DatePicker,
    vueDropzone: vue2Dropzone,
    Treeselect,
    LetterCube
  },
  data() {
    return {
      title: "Văn bản cần xử lý",
      items: [
        {
          text: "D-Office",
          href: "/"
        },
        {
          text: "Văn bản cần xử lý",
          href: "/xu-ly-van-ban-den"
        },
        {
          text: "Danh sách",
          active: true
        }
      ],
      data: [],
      showModal: false,
      showDetail: false,
      showDeleteModal: false,
      submitted: false,
      listCoQuan: [],
      listRole: [],
      currentUserRoles: CURRENT_USER.ROLES,
      model: vanBanDenModel.baseJson(),
      modelButPhe: butPheModel.baseJson(),
      modelPhanCong: phanCongModel.baseJson(),
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      totalRowsHistory: 1,
      todoTotalRows: 1,
      currentPage: 1,
      currentPageHistory: 1,
      numberOfElement: 1,
      numberOfElementHistory: 1,
      perPage: 20,
      pageOptions: [20, 50, 80, 100],
      perPageHistory: 10,
      pageOptionsHistory: [10, 20, 50, 80, 100],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      optionsDonViTree: [],
      isBusy: false,
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: 'STT',
          label: 'STT',
          thStyle: {width: '50px', minWidth: '50px'},
          class: "text-center content-capso",
          thClass: "text-primary hidden-sortable text-center",
        },
        {
          key: "soLuuCV",
          label: "Số lưu CV",
          class: "content-capso text-center ",
          thStyle: {width: '100px', minWidth: '100px'},
          thClass: "text-primary hidden-sortable text-center",
          sortable: true,
        },
        {
          key: "soVBDen",
          label: "Số VB đến",
          class: "content-capso",
          thStyle: {width: '150px', minWidth: '150px'},
          thClass: "text-primary hidden-sortable text-center",
          sortable: true,
        },
        {
          key: "trichYeu",
          label: "Trích yếu",
          class: "content-capso",
          // thStyle: {width: '100px', minWidth: '200px'},
          thClass: "text-primary hidden-sortable",
        },
        // {
        //   key: "loaiVanBan",
        //   label: "Loại văn bản",
        //   class: "text-center content-capso",
        //   thStyle: {width: '100px', minWidth: '100px'},
        //   thClass: "text-primary",
        // },
        {
          key: "trangThai",
          label: "Trạng thái",
          thStyle: {width: '100px', minWidth: '100px'},
          class: "text-center content-capso",
          thClass: "text-primary hidden-sortable",
        },
        {
          key: "hanXuLy",
          label: "Hạn Xử Lý",
          thStyle: {width: '100px', minWidth: '80px'},
          class: "content-capso",
          thClass: "text-primary hidden-sortable text-center",
        },
        {
          key: 'chuyenTrangThai',
          label: '',
          thStyle: {width: '110px', minWidth: '110px'},
          class: "text-center content-capso",
          sortable: false,
          thClass: 'hidden-sortable title-capso text-primary',
        },
        {
          key: 'process',
          label: 'Xử lý',
          thStyle: {width: '120px', minWidth: '120px'},
          thClass: "text-primary hidden-sortable text-center",
          class: "btn-process"
        }
      ],
      fieldsHistory: [
        {
          key: 'STT',
          label: 'STT',
          thStyle: {width: '30px', minWidth: '30px'},
          class: "text-center content-capso",
          thClass: 'hidden-sortable title-capso',
        },
        {
          key: "userName",
          label: "Người thực hiện",
          class: "content-capso",
          thStyle: {width: '250px', minWidth: '100px'},
          thClass: "hidden-sortable text-primary",
          sortable: true,
        },
        {
          key: "trangThai",
          label: "Trạng thái",
          thStyle: {width: '100px', minWidth: '100px'},
          class: "content-capso",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        },
        {
          key: "content",
          label: "Nội dung",
          thStyle: {width: '250px', minWidth: '200px'},
          class: "content-capso",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        },
        {
          key: "createdAt",
          label: "Thời gian thực hiện ",
          thStyle: {width: '100px', minWidth: '100px'},
          class: "content-capso text-center",
          thClass: "hidden-sortable text-primary",
        },
      ],
      optionsLoaiVanBan: [],
      optionsDonVi: [],
      optionsTreeDonVi: [],
      optionsKhoiCoQuan: [],
      optionsLinhVuc: [],
      optionsUser: [],
      optionsHinhThucNhan: [],
      optionsMucDo: [],
      optionsTrangThai: [],
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'fontfamily', 'fontsize', '|',
            'bold', 'italic', 'underline', '|',
            'alignment', '|',
            'undo', 'redo'
          ],
          shouldNotGroupWhenFull: false
        },
        removePlugins: ['Title', 'ImageCaption'],
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "files/upload-ckeditor",
          headers: {
            'Authorization': 'optional_token'
          }
        },
      },
      apiUrl: process.env.VUE_APP_API_URL,
      url: `${process.env.VUE_APP_API_URL}files/upload`,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 30,
        maxFilesize: 30,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif,.doc,.docx,.xlsx,.pptx,.pdf",
      },
      showModalButPhe: false,
      showModalPhanCong: false,
      phanCong: [],
      modelTrangThai: trangThaiModel.currentVBDBaseJson(),
      currentUserName: CURRENT_USER.USERNAME,
      showCheckVanBanModal: false,
      showTrangThaiModal: false,
      currentStatus: null,
      valueConsistsOf: 'ALL_WITH_INDETERMINATE',
      listHistoryQuestion: [],
      showHistoryModal: false,
      itemFilter: {
        title: null,
        donViSoan: null,
        nguoiSoan: null,
        trangThai: null,
        loaiVanBan: null
      },
      optionsTrangThaiAll: [],
      isCollapseSearch: false,
      noiDungXuLy: {
        daXuLy: false,
        noiDung: null,
        ngayXuLy: null,
        sysNgayXuLy: null,
        files: null
      },
      showModalDetailHistory: false,
    };
  },
  validations: {
    model: {
      loaiVanBan: {required},
      trangThai: {required},
    },
    modelTrangThai: {
      currentTrangThai: {required},
      newTrangThai: {required},
      userName: {required},
    }
  },
  computed: {
    checkVanThuTruong() {
      var checkVT = this.currentUserRoles.find(x => x.code == CONSTANTS.ROLE_VAN_THU_TRUONG || x.code == CONSTANTS.ROLE_VAN_THU_VAN_BAN_DEN);
      if (checkVT) {
        return true;
      }
      return false;
    },

  },
  watch: {
    showModalPhanCong() {
      if (this.showModalPhanCong == false) {
        this.phanCong = [];
      }
    },
    modelTrangThai: {
      deep: true,
      async handler(val) {

      }
    },
    modelButPhe: {
      deep: true,
      async handler(val) {

      }
    },

  },
  async created() {
    this.getLoaiVanBan();
    this.getTrangThai();
    this.getDonVi();
    this.getUser();
    this.getLinhVuc();
    this.getHinhThuc();
    this.getMucDo();
    this.getKhoiCoQuan();
    this.getTreeDonVi();
    this.getDonViTree();
    this.getAllTrangThai();
  },
  // mounted() {
  //   // Set the initial number of items
  //   this.totalRows = this.items.length;
  // },

  methods: {
    isNguoiChuTri(chuTri) {
      let checkCT = this.currentUserName == chuTri?.userName
      return checkCT;
    },
    async handleSubmitXuLy(m) {
      this.model = m;
      await this.$store.dispatch("vanBanDenStore/xuLyNhiemVuVanBanDen", this.model).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.$refs.tblList.refresh()
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      })
    },
    checkListNhomLanhDao(value) {
      if (value) {
        var index = value.findIndex(x => x && x.nguoiXuLy && x.nguoiXuLy.userName == this.currentUserName);
        if (index != -1)
          return true;
      }
      return false;
    },
    /**
     * Search the table data with search input
     */
    async fnGetList() {
      await this.onPageChange();
    },
    async onPageChange(page = 1) {
      this.pagination.currentPage = page;
      const params = {
        pageNumber: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }
      this.$refs.tblList?.refresh()
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async handleSubmit(e) {
      e.preventDefault();
      if (
          this.model.id != 0 &&
          this.model.id != null &&
          this.model.id
      ) {
        //Update model
        await this.$store.dispatch("vanBanDenStore/update", this.model).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showModal = false;
            this.model = vanBanDenModel.baseJson();
            this.$refs.tblList.refresh()
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));

        })
      } else {
        //Create modelhandleSubmit
        this.model.version = 1;
        await this.$store.dispatch("vanBanDenStore/create", this.model).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showModal = false;
            this.model = vanBanDenModel.baseJson()
            // this.$refs.myVueDropzone.removeAllFiles();
            this.$refs.tblList.refresh();
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        });
      }
    },
    async handleUpdate(id) {
      // await this.$store.dispatch("vanBanDenStore/getById", id).then((res) => {
      //   if (res.resultCode == "SUCCESS") {
      //     this.model = res.data;
      //     this.showModal = true;
      //   } else {
      //     // this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
      //   }
      // });
      this.$router.push({
        name: 'soan-van-ban-den',
        params: {id: id}
      });
    },
    async handleButPhe(e) {
      e.preventDefault();
      await this.$store.dispatch("vanBanDenStore/butPhe", this.modelButPhe).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.showModalButPhe = false;
          this.$refs.tblList.refresh()
        }
        this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
      });
    },
    async handlePhanCong(e) {
      e.preventDefault();
      this.modelPhanCong = this.phanCong;
      await this.$store.dispatch("vanBanDenStore/phanCong", this.modelPhanCong).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.showModal = false;
          this.phanCong = [];
        }
        this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        this.$refs.tblList.refresh()
      });
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    async handleDelete() {
      if (this.model.id != 0 && this.model.id != null && this.model.id) {
        await this.$store.dispatch("vanBanDenStore/delete", this.model.id).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showDeleteModal = false;
            this.model = vanBanDenModel.baseJson();
            this.$refs.tblList.refresh();
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        });
      }
    },
    handleDetail(id) {

    },
    HandleShowPhanCong(id) {
      this.modelPhanCong.vanBanDenId = id;
      this.phanCong.push({yKienChiDao: "", nguoiButPhe: "", NguoiNhanXuLy: "", vanBanDenId: id,});
      this.showModalPhanCong = true;
    },
    async handleShowButPhe(id) {
      await this.$store.dispatch("vanBanDenStore/getById", id).then(resp => {
        if (resp.resultCode == "SUCCESS") {
          this.loading = false
          this.model = resp.data;
          this.showModalButPhe = true;
          if (this.model.butPhe) {
            this.modelButPhe = this.model.butPhe;
          } else {
            this.modelButPhe = butPheModel.baseJson();
          }

          this.modelButPhe.vanBanDenId = id;
          return [];
        }
        return [];
      })
    },
    async getLoaiVanBan() {
      await this.$store.dispatch("loaiVanBanStore/getAll").then((res) => {
        if (res.resultCode === "SUCCESS") {
          this.optionsLoaiVanBan = res.data;
        } else {
          this.optionsLoaiVanBan = [];
        }
      });
    },
    handleCreate() {
      this.model = vanBanDenModel.baseJson();
      this.showModal = true;
      this.getTrangThai(null);
    },
    async getDonVi() {
      try {
        await this.$store.dispatch("donViStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsDonVi = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getTreeDonVi() {
      try {
        await this.$store.dispatch("donViStore/getDonViCha").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsTreeDonVi = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getKhoiCoQuan() {
      try {
        await this.$store.dispatch("khoiCoQuanStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsKhoiCoQuan = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUser = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getLinhVuc() {
      try {
        await this.$store.dispatch("dmLinhVucStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsLinhVuc = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getHinhThuc() {
      try {
        let promise = this.$store.dispatch("hinhThucGuiStore/get")
        return promise.then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsHinhThucNhan = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getMucDo() {
      await this.$store.dispatch("enumStore/getMucDo").then((res) => {
        if (res.resultCode === "SUCCESS") {
          this.optionsMucDo = res.data;
        } else {
          this.optionsMucDo = [];
        }
      });
    },
    removeThisFileVB(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.noiDungXuLy.files.filter(x => {
          return x.fileId != idFile;
        })
        this.noiDungXuLy.files = resultData;
      }
    },
    addThisFileVB(file, response, id) {
      if (this.noiDungXuLy.files == null || this.noiDungXuLy.files.length <= 0) {
        this.noiDungXuLy.files = [];
      }
      let fileSuccess = response.data;
      this.noiDungXuLy.files.push({fileId: fileSuccess.id, fileName: fileSuccess.fileName, ext: fileSuccess.ext})
    },
    removeThisFile(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.model.uploadFiles.filter(x => {
          return x.fileId != idFile;
        })
        this.model.uploadFiles = resultData;
      }
    },
    addThisFile(file, response) {
      if (this.showModalButPhe == true) {
        if (this.modelButPhe.uploadFiles == null || this.modelButPhe.uploadFiles <= 0) {
          this.modelButPhe.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.modelButPhe.uploadFiles.push({
          fileId: fileSuccess.id,
          fileName: fileSuccess.fileName,
          ext: fileSuccess.ext
        })
      }
      if (this.model) {
        if (this.model.uploadFiles == null || this.model.uploadFiles.length <= 0) {
          this.model.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.model.uploadFiles.push({fileId: fileSuccess.id, fileName: fileSuccess.fileName, ext: fileSuccess.ext})
      }
    },
    removeCommentFile(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.model.uploadFiles = null;
        this.model.uploadFiles = resultData;
      }
    },
    addCommentFile(file, response) {
      if (this.model) {
        if (this.model.uploadFiles == null || this.model.length <= 0) {
          this.model.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.model.uploadFiles = {fileId: fileSuccess.id, fileName: fileSuccess.fileName, ext: fileSuccess.ext}
      }
    },
    normalizer(node) {
      if (node.children == null || node.children == 'null') {
        delete node.children;
      }
    },
    AddformData(id) {
      this.phanCong.push({yKienChiDao: "", nguoiButPhe: "", NguoiNhanXuLy: "", vanBanDenId: id,});
    },
    deleteRow(index) {
      Swal.fire({
        title: "Bạn có chắc muốn xoá không?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Đồng ý"
      }).then(result => {
        if (result.value) {
          this.phanCong.splice(index, 1);
          Swal.fire({
            position: 'top-center',
            icon: 'success',
            title: 'Thành công',
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    formatRemoveDonVi1(node, instanceId) {
      let value = this.modelTrangThai.donVi?.find(x => x.id == node.id);
      if (value != null) {
        this.modelTrangThai.donVi = this.modelTrangThai.donVi.filter(x => x.id != value.id);
      }
    },
    formatDonVi1(node, instanceId) {
      let index = this.modelTrangThai.donVi?.findIndex(x => x.id == node.id);
      if (index == -1 || index == undefined) {
        if (!this.modelTrangThai.donVi) {
          this.modelTrangThai.donVi = [];
        }
        this.modelTrangThai.donVi.push({id: node.id, ten: node.label, code: node.code});

      }
    },
    formatDonVi(node, instanceId) {
      let index = this.optionsTreeDonVi?.findIndex(x => x.id == node.id);
      if (index == -1 || index == undefined) {
        if (!this.modelButPhe.donViPhoiHop) {
          this.modelButPhe.donViPhoiHop = [];
        }
        this.modelButPhe.donViPhoiHop.push({id: node.id, ten: node.label, code: node.code});

      }
    },
    formatRemoveDonVi(node, instanceId) {
      let value = this.optionsTreeDonVi?.find(x => x.id == node.id);
      if (value != null) {
        this.modelButPhe.donViPhoiHop = this.optionsTreeDonVi.children.filter(x => x.id != value.id);
      }
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        loaiVanBan: this.itemFilter.loaiVanBan,
        trangThai: this.itemFilter.trangThai,
        content: this.itemFilter.title,
        nguoiSoan: this.itemFilter.nguoiSoan,
        donViSoan: this.itemFilter.donViSoan
      }
      this.loading = true

      try {
        let promise = this.$store.dispatch("vanBanDenStore/getPagingParamsXuLy", params)
        return promise.then(resp => {
          let items = resp.data.data
          this.totalRows = resp.data.totalRows
          this.numberOfElement = resp.data.data.length
          this.loading = false
          items.map(value => {
            if (value.noiDungXuLy == null) {
              value.noiDungXuLy = {
                daXuLy: false,
                noiDung: null,
                ngayXuLy: null,
                sysNgayXuLy: null,
                files: null
              }
            }
          })
          return items || []
        })
      } finally {
        this.loading = false
      }
    },

    // Trang thai van ban
    async getTrangThai(currentTrangThai) {
      try {
        await this.$store.dispatch("trangThaiStore/getNextTrangThai", {
          loaiTrangThai: "VBDen",
          currentTrangThai: currentTrangThai,
        }).then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data;
            this.loading = false
            this.optionsTrangThai = items;
            return items || []
          }
          return [];
        })
      } finally {
        this.loading = false
      }
    },
    async getDonViTree() {
      try {
        await this.$store.dispatch("donViStore/getTree").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsDonViTree = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    handleChuyenTrangThai: function (currentStatus, vanBanDenId) {
      this.getTrangThai(currentStatus)
      this.modelTrangThai.currentTrangThai = currentStatus;
      this.modelTrangThai.newTrangThai = null;
      this.modelTrangThai.vanBanDenId = vanBanDenId;
      this.modelTrangThai.userName = this.currentUserName;
      this.showTrangThaiModal = true;
    },
    async handleCheckVanBanModal(id) {
      await this.$store.dispatch("vanBanDenStore/getById", id).then((res) => {
        if (res.resultCode == "SUCCESS") {
          this.model = res.data;
          this.getTrangThai(this.model.trangThai)
          this.modelTrangThai.currentTrangThai = this.model.trangThai;
          this.modelTrangThai.newTrangThai = null;
          this.modelTrangThai.vanBanDenId = this.model.id;
          this.modelTrangThai.userName = this.currentUserName;
          this.showCheckVanBanModal = true;
        } else {
          // this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async handleXuLyVanBan(id) {

    },
    showLoading(){
      let loader = this.$loading.show({
        container: this.$refs.formContainerTrangThai,
      },{
        default: this.$createElement(LetterCube),
      });
      return loader;
    },
    async handleChuyenTrangThaiVanBan(value) {
      if (value) {
        this.modelTrangThai.newTrangThai = value;
      }
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.modelTrangThai.$invalid) {
        return;
      } else {
        if (
            this.modelTrangThai
            && this.modelTrangThai.vanBanDenId != null
        ) {
          let loader = this.showLoading();
          //Update model
          await this.$store.dispatch("vanBanDenStore/chuyenTrangThaiVanBan", this.modelTrangThai).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showTrangThaiModal = false;
              this.showCheckVanBanModal = false;
              this.modelTrangThai = trangThaiModel.currentVBDBaseJson()
              this.$refs.tblList.refresh();
            }
            loader.hide();

            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          })
        }
      }
      this.submitted = false;


    },
    async handleHistory(id) {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      await this.$store.dispatch("historyVanBanStore/getHistoryVanBanDi", id).then((res) => {
        if (res.resultCode == "SUCCESS") {
          this.listHistoryQuestion = res.data;
          this.showHistoryModal = true;
          this.numberOfElementHistory = this.listHistoryQuestion.length
          this.totalRowsHistory = this.listHistoryQuestion.length

          loader.hide();
        }
      });
    },
    handleSearch() {
      this.isSearch = true;
      this.$refs.tblList.refresh()
    },
    handleClear() {
      this.itemFilter = {
        title: null,
        donViSoan: null,
        nguoiSoan: null,
        trangThai: null,
        loaiVanBan: null
      }
      this.isSearch = true;
      this.$refs.tblList.refresh();
    },
    async getAllTrangThai() {
      await this.$store.dispatch("trangThaiStore/getTrangThai").then(resp => {
        if (resp.resultCode == "SUCCESS") {
          let items = resp.data

          this.optionsTrangThaiAll = items;
        }
        return [];
      });
    },
    clearSearch() {
      this.itemFilter.title = null;
      this.itemFilter.donViSoan = null;
      this.itemFilter.nguoiSoan = null;
      this.itemFilter.trangThai = null;
      this.itemFilter.loaiVanBan = null;
    },
    handleShowFile(id) {
      let route = this.$router.resolve({path: '/xem-tep-tin/' + id});
      window.open(route.href, '_blank');
    },
    onTabBaoCao(item) {
      if (item) {
        this.noiDungXuLy = item.noiDungXuLy;
      }
    },
    handleDeleteFile(index) {
      if (this.noiDungXuLy) {
        if (this.noiDungXuLy.files) {
          this.noiDungXuLy.files.splice(index, 1);
        }
      }
    },
    handleDetailHistory(id) {
      this.showModalDetailHistory = true;
    },
    rowClass(item) {
      let classDelay = '';
      if (item.hanXuLy) {
        classDelay = "cs-table-delay";
      }
      return "b-table-vbden " + classDelay;
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark">Văn bản cần xử lý</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <b-button v-b-toggle.collapseSearch variant="light"
                          class="btn w-md btn-primary-outline me-2" size="sm">
                  <i class="fas fa-caret-down align-middle me-2"></i>
                  Tìm kiếm
                </b-button>
                <!--                <b-button-->
                <!--                    v-if="isVanThu"-->
                <!--                    variant="primary"-->
                <!--                    class="btn w-md btn-primary"-->
                <!--                    @click="handleCreate"-->
                <!--                    size="sm"-->
                <!--                >-->
                <!--                  <i class="mdi mdi-plus align-middle me-2"></i> Nhập văn bản-->
                <!--                </b-button>-->
              </div>
            </div>
            <b-collapse id="collapseSearch" class="mt-1">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                    <!-- Nội dung -->
                    <div class="flex-grow-1 me-2">
                      <label>Nội dung</label>
                      <input
                          size="sm"
                          type="text"
                          name="untyped-input"
                          class="form-control"
                          v-model="itemFilter.title"
                          placeholder="Trích yếu/Số lưu CV/..."
                      />
                    </div>
                    <!-- Đơn vị soạn-->
                    <div class="flex-grow-1 me-2">
                      <label>Đơn vị soạn</label>
                      <multiselect
                          v-model="itemFilter.donViSoan"
                          :options="optionsDonVi"
                          track-by="id"
                          label="ten"
                          placeholder="Chọn đơn vị soạn"
                          deselect-label="Nhấn để xoá"
                          selectLabel="Nhấn enter để chọn"
                          selectedLabel="Đã chọn"
                      ></multiselect>
                    </div>
                    <!-- Loại văn bản -->
                    <div class="flex-grow-1 me-2">
                      <label>Loại văn bản</label>
                      <multiselect
                          v-model="itemFilter.loaiVanBan"
                          :options="optionsLoaiVanBan"
                          track-by="id"
                          selectLabel="Nhấn vào để chọn"
                          deselectLabel="Nhấn vào để xóa"
                          class="helo"
                          label="ten"
                          placeholder="Chọn loại văn bản"
                      ></multiselect>
                    </div>
                    <!--  Xử lý -->
                    <div class="flex-grow-0 ms-2">
                      <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="handleSearch" variant="light"
                                    class="btn w-md btn-primary me-2" size="md">
                            <i class="fas fa-search align-middle me-2"></i>
                            Tìm kiếm
                          </b-button>
                        </div>
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="clearSearch" variant="light"
                                    class="btn w-md btn-secondary me-2" size="md">
                            <i class="fas fa-redo-alt align-middle me-2"></i>
                            Làm mới
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <!--                  <b-button-->
                  <!--                      variant="primary"-->
                  <!--                      type="button"-->
                  <!--                      class="btn w-md btn-primary"-->
                  <!--                      @click="handleCreate"-->
                  <!--                      size="sm"-->
                  <!--                  >-->
                  <!--                    <i class="mdi mdi-plus me-1"></i> Thêm mới-->
                  <!--                  </b-button>-->
                  <!-- Model create -->
                  <b-modal
                      v-model="showModal"
                      title="Tiếp nhận văn bản đến"
                      title-class="text-black font-18"
                      body-class="p-3"
                      hide-footer
                      centered
                      no-close-on-backdrop
                      size="xl"
                  >
                    <form @submit.prevent="handleSubmit"
                          ref="formContainer">
                      <div class="row">
                        <div class="col-lg-7 col-md-12">
                          <div class="row">

                            <!--                            Loại văn bản-->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Loại văn bản</label> <span
                                  class="text-danger">*</span>
                                <multiselect
                                    v-model="model.loaiVanBan"
                                    :options="optionsLoaiVanBan"
                                    track-by="id"
                                    label="ten"
                                    placeholder="Chọn trạng thái"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                ></multiselect>
                                <div
                                    v-if="submitted && $v.model.loaiVanBan.$error"
                                    class="invalid-feedback"
                                >
                                <span v-if="!$v.model.loaiVanBan.required"
                                >Vui lòng thêm số văn bản đến.</span
                                >
                                </div>
                              </div>
                            </div>
                            <!--                            Trạng thái-->
                            <div class="col-md-6">

                              <div v-if="model.trangThai && model.id" class="mb-2">
                                <label class="form-label" for="validationCustom01">Trạng thái</label> <span
                                  class="text-danger">*</span>
                                <input
                                    id="validationCustom01"
                                    :value="model.trangThai.ten"
                                    type="text"
                                    class="form-control"
                                    placeholder=""
                                    disabled
                                />
                              </div>

                              <div v-else class="mb-2">
                                <label class="form-label" for="validationCustom01">Trạng thái</label> <span
                                  class="text-danger">*</span>
                                <multiselect
                                    v-model="model.trangThai"
                                    :options="optionsTrangThai"
                                    track-by="id"
                                    label="ten"
                                    placeholder="Chọn trạng thái"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                    :class="{
                                'is-invalid':
                                  submitted && $v.model.trangThai.$error,
                                }"
                                ></multiselect>
                                <div
                                    v-if="submitted && !$v.model.trangThai.required"
                                    class="invalid-feedback"
                                >
                                  Trạng thái không được để trống.
                                </div>
                              </div>
                            </div>
                            <!--                              Số lưu -->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Số lưu VB</label>
                                <input
                                    id="validationCustom01"
                                    v-model="model.soLuuCV"
                                    type="text"
                                    class="form-control"
                                    placeholder="eg: 123-dthu"
                                />
                              </div>
                            </div>
                            <!--                            Số VB đến -->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Số văn bản đến</label>
                                <input
                                    id="validationSoVBDen"
                                    v-model="model.soVBDen"
                                    type="text"
                                    class="form-control"
                                    placeholder="eg: 123-dthu"
                                />
                              </div>
                            </div>
                            <!--                            Trích yếu -->
                            <div class="col-md-12">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Trích yếu</label>
                                <textarea
                                    v-model="model.trichYeu"
                                    name=""
                                    id="trichyeu"
                                    rows="3"
                                    class="form-control"
                                ></textarea>
                              </div>
                            </div>
                            <!--                            Ngày ban hành -->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Ngày ban hành</label>
                                <date-picker v-model="model.ngayBanHanh"
                                             format="DD/MM/YYYY"
                                             value-type="format"
                                >
                                  <div slot="input">
                                    <input v-model="model.ngayBanHanh"
                                           v-mask="'##/##/####'" type="text" class="form-control"
                                           placeholder="Nhập ngày ban hành"/>
                                  </div>
                                </date-picker>
                              </div>
                            </div>
                            <!--                            Ngày nhận -->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Ngày nhận</label>
                                <date-picker v-model="model.ngayNhan"
                                             format="DD/MM/YYYY"
                                             value-type="format"
                                >
                                  <div slot="input">
                                    <input v-model="model.ngayNhan"
                                           v-mask="'##/##/####'" type="text" class="form-control"
                                           placeholder="Nhập ngày nhận"/>
                                  </div>
                                </date-picker>
                              </div>
                            </div>
                            <div v-if="model.id">
                              <div v-if="model.file != null  && model.file.length > 0" class="col-md-12">
                                <label for="">Danh sách đã ký (Nhấn vào để tải xuống)</label>
                                <div
                                    class=" p-1"
                                >
                                  <template>
                                    <div v-for="(file, index) in model.file" :key="index">
                                      <a
                                          :href="`${apiUrl}files/view/${file.fileId}`"
                                          class=" fw-medium"
                                      ><i
                                          :class="`mdi font-size-16 align-middle me-2`"
                                      ></i>
                                        {{ index + 1 }}: {{ file.fileName }}</a
                                      >
                                    </div>
                                  </template>
                                </div>

                              </div>
                            </div>

                            <!--                            file đính kèm-->
                            <div class="col-md-12">
                              <label for=""> Văn bản đính kèm</label>
                              <vue-dropzone
                                  id="dropzone"
                                  ref="myVueDropzone"
                                  :use-custom-slot="true"
                                  :options="dropzoneOptions"
                                  v-on:vdropzone-removed-file="removeThisFile"
                                  v-on:vdropzone-success="addThisFile"
                              >
                                <div class="dropzone-custom-content">
                                  <i
                                      class="display-1 text-muted bx bxs-cloud-upload"
                                      style="font-size: 70px"
                                  ></i>
                                  <h4>
                                    Kéo thả tệp tin hoặc bấm vào để tải tệp tin
                                  </h4>
                                </div>
                              </vue-dropzone>
                            </div>
                          </div>

                        </div>
                        <div class="col-lg-5 col-md-12">
                          <div class="row">
                            <!--                            Ngày Ký-->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Ngày ký</label>
                                <date-picker v-model="model.ngayKy"
                                             format="DD/MM/YYYY"
                                             value-type="format"
                                >
                                  <div slot="input">
                                    <input v-model="model.ngayKy"
                                           v-mask="'##/##/####'" type="text" class="form-control"
                                           placeholder="Nhập ngày ký"/>
                                  </div>
                                </date-picker>
                              </div>
                            </div>
                            <!--                            Thời hạn xử lý-->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Thời hạn xử lý</label>
                                <date-picker v-model="model.hanXuLy"
                                             format="DD/MM/YYYY"
                                             value-type="format"
                                >
                                  <div slot="input">
                                    <input v-model="model.hanXuLy"
                                           v-mask="'##/##/####'" type="text" class="form-control"
                                           placeholder="Nhập hạn xử lý"/>
                                  </div>
                                </date-picker>
                              </div>
                            </div>
                            <!--                            Người ký-->
                            <div class="col-md-12">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Người ký</label>
                                <multiselect
                                    v-model="model.nguoiKy"
                                    :options="optionsUser"
                                    track-by="id"
                                    label="fullName"
                                    placeholder="Chọn người ký"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                >
                                  <template slot="singleLabel" slot-scope="{ option }">
                                    <strong>{{ option.fullName }}</strong>

                                    <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                                  </template>
                                  <template slot="option" slot-scope="{ option }">
                                    <div class="option__desc">
                                      <span class="option__title">
                                        <strong>{{ option.fullName }}&nbsp;</strong>
                                      </span>
                                      <span v-if="option.donVi" class="option__small"
                                            style="color:green">{{ option.donVi.ten }}</span>
                                    </div>
                                  </template>
                                </multiselect>
                              </div>
                            </div>


                            <!--                            Khối cơ quan gửi-->
                            <div class="col-md-12">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Khối cơ quan gửi</label>
                                <multiselect
                                    v-model="model.khoiCoQuanGui"
                                    :options="optionsKhoiCoQuan"
                                    track-by="id"
                                    label="ten"
                                    placeholder="Chọn trạng thái"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                ></multiselect>
                              </div>
                            </div>
                            <!--                            Cơ quan gửi-->
                            <div class="col-md-12">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Cơ quan gửi</label>
                                <multiselect
                                    v-model="model.coQuanGui"
                                    :options="optionsDonVi"
                                    track-by="id"
                                    label="ten"
                                    placeholder="Chọn trạng thái"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                ></multiselect>
                              </div>
                            </div>
                            <!--                            Hình thức nhận -->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Hình thức nhận</label>
                                <multiselect
                                    v-model="model.hinhThucNhan"
                                    :options="optionsHinhThucNhan"
                                    track-by="id"
                                    label="ten"
                                    placeholder="Chọn hình thức nhận"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                ></multiselect>
                              </div>
                            </div>
                            <!--                            Lĩnh vực-->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Lĩnh vực</label>
                                <multiselect
                                    v-model="model.linhVuc"
                                    :options="optionsLinhVuc"
                                    track-by="id"
                                    label="ten"
                                    placeholder="Chọn lĩnh vực"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                ></multiselect>
                              </div>
                            </div>
                            <!--                            Mức độ tính chất-->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Mức độ tính chất</label>
                                <multiselect
                                    v-model="model.mucDoTinhChat"
                                    :options="optionsMucDo"
                                    track-by="id"
                                    label="name"
                                    placeholder="Chọn mức độ tính chất"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                ></multiselect>
                              </div>
                            </div>
                            <!--                            Mức độ bảo mật-->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Mức độ bảo mật</label>
                                <multiselect
                                    v-model="model.mucDoBaoMat"
                                    :options="optionsMucDo"
                                    track-by="id"
                                    label="name"
                                    placeholder="Chọn mức độ bảo mật"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                ></multiselect>
                              </div>
                            </div>
                            <!--                            Hồ sơ đơn vị-->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Hồ sơ đơn vị</label>
                                <input
                                    v-model="model.hoSoDonVi"
                                    type="text"
                                    class="form-control"
                                    placeholder=""
                                />
                              </div>
                            </div>
                            <!--                            Nơi lưu trữ-->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label" for="validationCustom01">Nơi lưu trữ</label>
                                <input
                                    v-model="model.noiLuuTru"
                                    type="text"
                                    class="form-control"
                                    placeholder="Nhập nơi lưu trữ"
                                />
                              </div>
                            </div>
                            <!--                            Điều kiện-->
                            <!--                            <div class="col-md-12">-->
                            <!--                              <div class="mb-2 d-flex align-items-center">-->
                            <!--                                <switches v-model="model.congVanChiDoc" color="primary" class="ml-1 mx-2"></switches>-->
                            <!--                                <label for="">Là công văn chỉ đọc</label>-->
                            <!--                              </div>-->
                            <!--                              <div class="mb-2 d-flex align-items-center">-->
                            <!--                                <switches v-model="model.banChinh" color="primary" class="ml-1 mx-2"></switches>-->
                            <!--                                <label for=""> Là bản chính</label>-->
                            <!--                              </div>-->
                            <!--                              <div class="mb-2 d-flex align-items-center">-->
                            <!--                                <switches v-model="model.hienThiThongBao" color="primary" class="ml-1 mx-2"></switches>-->
                            <!--                                <label for="">Hiển thị mục thông báo</label>-->
                            <!--                              </div>-->
                            <!--                            </div>-->
                          </div>
                        </div>
                      </div>
                      <div class="text-end pt-2 mt-3">
                        <b-button variant="light" class="w-md" size="sm" @click="showModal = false">
                          Đóng
                        </b-button>
                        <b-button type="submit" variant="primary" size="sm" class="ms-1 w-md">
                          Lưu
                        </b-button>
                      </div>
                    </form>
                  </b-modal>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!--            Hiển thị dòng-->
                <!--                <div class="row mb-2">-->
                <!--                  <div class="col-sm-12 col-md-6">-->
                <!--                    <div id="tickets-table_length" class="dataTables_length">-->
                <!--                      <label class="d-inline-flex align-items-center">-->
                <!--                        Hiện-->
                <!--                        <b-form-select-->
                <!--                            class="form-select form-select-sm"-->
                <!--                            v-model="perPage"-->
                <!--                            size="sm"-->
                <!--                            :options="pageOptions"-->
                <!--                        ></b-form-select-->
                <!--                        >&nbsp;dòng-->
                <!--                      </label>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!-- Table -->
                <div class="table-responsive-sm table-responsive">
                  <b-table
                      class="datatables cs-table-xulyvbd"
                      :items="myProvider"
                      :fields="fields"
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      ref="tblList"
                      primary-key="id"
                      :busy.sync="isBusy"
                      :tbody-tr-class="rowClass"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(loaiVanBan)="data">
                      <span v-if="data.item.loaiVanBan"> {{ data.item.loaiVanBan.ten }}</span>
                    </template>
                    <template v-slot:cell(soVBDen)="data">
                      <div v-if="data.item.soVBDen">{{ data.item.soVBDen }}</div>
                    </template>
                    <template v-slot:cell(hanXuLy)="data">
                      <div v-if="data.item.hanXuLy">
                        <p class="text-danger px-2"
                           style="background-color: rgba(236,69,97,0.1); border-radius: 3px; width: fit-content; margin: 5px auto"
                        >
                          {{ data.item.hanXuLy }}
                        </p>
                      </div>
                    </template>
                    <template v-slot:cell(trangThai)="data">
                      <span v-if="data.item.trangThai" class="badge"
                            :class="'bg-' + data.item.trangThai.bgColor"> {{ data.item.trangThai.ten }}</span>
                    </template>
                    <template v-slot:cell(trichYeu)="data">
                      <div v-if="data.item.trichYeu" :inner-html.prop="data.item.trichYeu | truncate(150)">
                      </div>
                    </template>
                    <template v-slot:cell(chuyenTrangThai)="data">

                      <b-button
                          v-if="data.item.ower && data.item.ower.userName == currentUserName
                          && (data.item.trangThai.code == 'TTKHTVBD'  || data.item.trangThai.code == 'TLDVBD')"
                          type="button"
                          size="sm"
                          class="btn btn-light btn-danger"
                          data-toggle="tooltip" data-placement="bottom" title="Xử lý văn bản"
                          v-on:click="handleCheckVanBanModal(data.item.id)">
                        <i class="fas fa-exchange-alt  me-1"></i>
                        Xử lý VB
                      </b-button>
<!--                      <b-button-->
<!--                          v-if="data.item.butPhe && data.item.butPhe.nguoiChuTri && data.item.butPhe.nguoiChuTri.userName == currentUserName"-->
<!--                          type="button"-->
<!--                          size="sm"-->
<!--                          class="btn btn-light btn-danger"-->
<!--                          data-toggle="tooltip" data-placement="bottom" title="Xử lý văn bản"-->
<!--                          v-on:click="handleXuLyVanBan(data.item.id)">-->
<!--                        <i class="fas fa-exchange-alt  me-1"></i>-->
<!--                        Xử lý VB 2-->
<!--                      </b-button>-->
                      <b-button
                          v-if="(data.item.ower && data.item.ower.userName == currentUserName && (data.item.trangThai.code == 'KTVBD' || data.item.trangThai.code == 'DVBD' || data.item.trangThai.code == 'TCVBD' || data.item.trangThai.code == 'HTXLVBD' || data.item.trangThai.code == 'KHTXLVBD')) || ((currentUserName == 'D2570530.000853' || currentUserName == 'D2570030.000259') && data.item.trangThai.code == 'DVBD')"
                          type="button"
                          size="sm"
                          class="btn btn-light btn-danger"
                          data-toggle="tooltip" data-placement="bottom" title="Xử lý văn bản"
                          v-on:click="handleChuyenTrangThai(data.item.trangThai,data.item.id)">
                        <i class="fas fa-exchange-alt  me-1"></i>
                        Xử lý VB
                      </b-button>
                    </template>
                    <template v-slot:cell(process)="data">
                      <div class="d-flex justify-content-center">
                        <button
                            type="button"
                            size="sm"
                            class="btn btn-sm btn-detail"
                            data-toggle="tooltip" data-placement="bottom" title="Chi tiết"
                            v-b-toggle="'collapse-' + data.item.id"
                            @click="data.toggleDetails"
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                        <b-dropdown
                            id="dropdown-right"
                            right
                            variant="outline"
                            class="cs-btn-dropdown"
                            menu-class="dropdown-menu-end"
                        >
                          <template v-slot:button-content>
                            ...
                          </template>
                          <b-dropdown-item
                              v-if="checkVanThuTruong" v-on:click="handleUpdate(data.item.id)"
                          >
                            <div class="d-flex align-items-center">
                              <button
                                  v-if="checkVanThuTruong"
                                  type="button"
                                  size="sm"
                                  class="btn btn-sm btn-edit"
                                  data-toggle="tooltip" data-placement="bottom" title="Cập nhật"
                                  v-on:click="handleUpdate(data.item.id)">
                                <i class="fas fa-pencil-alt"></i>
                              </button>
                              <span class="ms-2">Chỉnh sửa</span>
                            </div>
                          </b-dropdown-item>
                          <b-dropdown-item
                              v-if="checkListNhomLanhDao(data.item.nhomNguoiTiepNhanVBTrinhLD)"
                              v-on:click="handleShowButPhe(data.item.id)">
                            <div
                                class="d-flex align-items-center">
                              <button
                                  v-if="checkListNhomLanhDao(data.item.nhomNguoiTiepNhanVBTrinhLD)"
                                  type="button"
                                  size="sm"
                                  class="btn btn-sm btn-butphe"
                                  data-toggle="tooltip" data-placement="bottom" title="Bút phê"
                                  v-on:click="handleShowButPhe(data.item.id)">
                                <i class="fas fa-feather-alt"></i>
                              </button>
                              <span class="ms-2">Bút phê</span>
                            </div>
                          </b-dropdown-item>
                          <b-dropdown-item
                              v-on:click="handleHistory(data.item.id)"
                              class="d-flex align-items-center">
                            <div>
                              <button
                                  type="button"
                                  size="sm"
                                  class="btn btn-sm btn-history"
                                  data-toggle="tooltip" data-placement="bottom" title="Lịch sử"
                                  v-on:click="handleHistory(data.item.id)">
                                <i class="fas fa-history"></i>
                              </button>
                              <span class="ms-2">Lịch sử</span>
                            </div>
                          </b-dropdown-item>
                          <b-dropdown-item
                              v-if="checkVanThuTruong"
                              v-on:click="handleShowDeleteModal(data.item.id)">
                            <div
                                class="d-flex align-items-center"
                            >
                              <button
                                  v-if="checkVanThuTruong"
                                  type="button"
                                  size="sm"
                                  class="btn btn-sm btn-delete"
                                  data-toggle="tooltip" data-placement="bottom" title="Xóa"
                                  v-on:click="handleShowDeleteModal(data.item.id)">
                                <i class="fas fa-trash-alt"></i>
                              </button>
                              <span class="ms-2">Xoá</span>
                            </div>
                          </b-dropdown-item>
                        </b-dropdown>


                        <!--                        <button-->
                        <!--                            type="button"-->
                        <!--                            size="sm"-->
                        <!--                            class="btn btn-outline btn-sm p-0"-->
                        <!--                            data-toggle="tooltip" data-placement="bottom" title="Chi tiết"-->
                        <!--                            v-on:click="handleDetail(data.item.id)">-->
                        <!--                          <i class="fas fa-eye  text-warning me-1"></i>-->
                        <!--                        </button>-->


                        <!--                        <button-->
                        <!--                            type="button"-->
                        <!--                            size="sm"-->
                        <!--                            class="btn btn-outline btn-sm p-0"-->
                        <!--                            data-toggle="tooltip" data-placement="bottom" title="Cập nhật"-->
                        <!--                            v-on:click="HandleShowPhanCong(data.item.id)">-->
                        <!--                          <i class="fas fa-user-plus text-info me-1"></i>-->
                        <!--                        </button>-->


                      </div>
                    </template>
                    <template v-slot:cell(ten)="data">
                      {{ data.item.ten }}
                    </template>
                    <template #row-details="data">
                      <b-collapse :id="`collapse-${data.item.id}`">
                        <b-card
                            class="show-detail-vbd cs-close-tabs"
                        >
                          <button
                              type="button"
                              size="sm"
                              class="btn btn-outline btn-sm p-0 item-close-tabs"
                              data-toggle="tooltip" data-placement="bottom" title="Chi tiết"
                              v-b-toggle="'collapse-' + data.item.id"
                              @click="data.toggleDetails"
                          >
                            <i class="fas fa-plus me-1 item-icon fs-3 text-danger"></i>
                          </button>
                          <b-tabs content-class="p-3 bg-white">
                            <b-tab active class="border-0">
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="fa fa-file-alt"></i>
                                </span>
                                <span class="d-none d-sm-inline-block">Thông tin văn bản</span>
                              </template>
                              <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                  <div class="d-flex justify-content-start">
                                    <div
                                        class="avatar-sm bg-soft-dark rounded-circle d-flex justify-content-center align-items-center">
                                      <i class="fas fa-info"></i>
                                    </div>
                                    <div class="px-3">
                                      <div v-if="data.item.soLuuCV" class="d-flex justify-content-start mb-1">
                                        <p class="mb-0 text-primary me-2">Số lưu VB:</p>
                                        <p class="mb-0 fw-medium text-black-2a"> {{ data.item.soLuuCV }}</p>
                                      </div>
                                      <div v-if="data.item.soVBDen" class="d-flex justify-content-start mb-1">
                                        <p class="mb-0 text-primary me-2">Số VB đến:</p>
                                        <p class="mb-0 fw-medium text-black-2a"> {{ data.item.soVBDen }}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <hr>
                                  <div class="">
                                    <div v-if="data.item.ngayBanHanh" class="d-flex justify-content-start mb-1">
                                      <p class="mb-0 text-primary me-2">Ngày ban hành:</p>
                                      <p class="mb-0 fw-medium text-black-2a"> {{ data.item.ngayBanHanh }}</p>
                                    </div>
                                    <div v-if="data.item.loaiVanBan" class="d-flex justify-content-start mb-1">
                                      <p class="mb-0 text-primary me-2">Loại văn bản:</p>
                                      <p class="mb-0 fw-medium text-black-2a"> {{ data.item.loaiVanBan.ten }}</p>
                                    </div>
                                    <div v-if="data.item.trangThai" class="d-flex justify-content-start mb-1">
                                      <p class="mb-0 text-primary me-2">Trạng thái:</p>
                                      <p
                                          class="mb-0 fw-medium text-white px-2"
                                          :class="'bg-' + data.item.trangThai.bgColor"
                                          style="border-radius: 3px;"
                                      > {{ data.item.trangThai.ten }}</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-6 col-12">
                                  <div>
                                    <ol class="activity-feed">
                                      <li class="feed-item">
                                        <div class="feed-item-list">
                                          <span class="date">Ngày nhận</span>
                                          <span class="activity-text badge badge-soft-success font-size-14">{{
                                              data.item.ngayNhan
                                            }}</span>
                                        </div>
                                      </li>
                                      <li class="feed-item feed-item-red">
                                        <div class="feed-item-list">
                                          <span class="date">Hạn xử lý</span>
                                          <span class="activity-text badge badge-soft-danger font-size-14">{{
                                              data.item.hanXuLy
                                            }}</span>
                                        </div>
                                      </li>
                                    </ol>
                                  </div>
                                </div>
                                <div class="col-lg-3 col-md-6 col-12">
                                  <div v-if="data.item.nguoiKy" class="d-flex flex-column justify-content-start mb-1">
                                    <p class="mb-0 text-primary me-2">Người ký:</p>
                                    <p class="mb-0 fw-medium text-black-2a"><i class="mdi mdi-account"></i>
                                      {{ data.item.nguoiKy.fullName }}</p>
                                  </div>
                                  <div v-if="data.item.ngayKy" class="d-flex flex-column justify-content-start mb-1">
                                    <p class="mb-0 text-primary me-2">Ngày ký:</p>
                                    <p class="mb-0 fw-medium text-black-2a"><i class="mdi mdi-calendar-month"></i>
                                      {{ data.item.ngayKy }}</p>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div>
                                    <div v-if="data.item.trichYeu" class="mb-1">
                                      <p class="mb-0 text-primary"><i class="mdi mdi-tag mdi-rotate-135"></i> Trích yếu:
                                      </p>
                                      <p
                                          class="mb-0 text-black-2a p-2"
                                          style="border: 0.5px dotted #ccc; border-radius: 3px;"
                                          :inner-html.prop="data.item.trichYeu"
                                      >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div v-if="data.item.file" class="col-sm-12">
                                  <p class="mb-0 text-primary"><i class="mdi mdi-folder"></i> Văn bản đính kèm:</p>
                                  <div class="mb-1 d-flex file-box">
                                    <div
                                        v-for="(value, index) in data.item.file" :key="index"
                                        class="mb-1 me-2"
                                        style="background-color: rgba(47,147,224,0.2); border-radius: 3px; padding: 5px;"
                                    >
                                      <a
                                          :href="`${apiUrl}files/view/${value.fileId}`"
                                          class=" fw-medium"
                                      ><i
                                          class="fas fa-cloud-download-alt text-primary mx-2"
                                      ></i>
                                        [Tải về]
                                      </a>
                                      <a v-if="value.ext=='.pdf'" style="cursor: pointer"
                                         @click="handleShowFile(value.fileId)"
                                         class="text-danger fw-medium">
                                        [Xem]
                                      </a>
                                      <span
                                          style="font-weight: 500; color: #2F93E0"
                                          class="px-2"
                                      >
                                        {{ value.fileName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </b-tab>
                            <b-tab @click="onTabBaoCao(data.item)">
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="fas fa-folder-open"></i>
                                </span>
                                <span class="d-none d-sm-inline-block">Báo cáo đánh giá</span>
                              </template>
                              <div class="content-butphe" v-if="data.item.butPhe">
                                <!--Thông tin người bút phê-->
                                <div class="card mb-3">
                                  <div
                                      class="p-3"
                                      style="border-radius: 3px; border: 0.5px solid #ccc;">
                                    <div class="row">
                                      <div class="col-12" v-if="data.item.butPhe.nguoiButPhe">
                                        <div
                                            class="d-flex align-items-center"
                                        >
                                          <p class="mb-0 text-primary fw-medium me-3">Người bút phê:</p>
                                          <p class="mb-0 text-dark text-uppercase">
                                            {{ data.item.butPhe.nguoiButPhe.fullName }}</p>
                                        </div>
                                      </div>
                                      <div class="col-12" v-if="data.item.butPhe.ngayButPhe">
                                        <div
                                            class="d-flex align-items-center"
                                        >
                                          <p class="mb-0 text-primary fw-medium me-3">Thời gian bút phê:</p>
                                          <p class="mb-0 text-muted">{{ data.item.butPhe.ngayButPhe }}</p>
                                        </div>
                                      </div>
                                      <div class="col-12">
                                        <div
                                            v-if="data.item.butPhe.mucDoQuanTrong"
                                            class="d-flex align-items-center"
                                        >
                                          <p class="mb-0 text-primary fw-medium me-3">Mức độ quan trọng:</p>
                                          <div v-if="data.item.butPhe.mucDoQuanTrong.code == 'THAP'">
                                            <p class="mb-0 bp-text-success">
                                              {{ data.item.butPhe.mucDoQuanTrong.name }}</p>
                                          </div>
                                          <div v-if="data.item.butPhe.mucDoQuanTrong.code == 'BINHTHUONG'">
                                            <p class="mb-0 bp-text-warning">
                                              {{ data.item.butPhe.mucDoQuanTrong.name }}</p>
                                          </div>
                                          <div v-if="data.item.butPhe.mucDoQuanTrong.code == 'CAO'">
                                            <p class="mb-0 bp-text-danger">
                                              {{ data.item.butPhe.mucDoQuanTrong.name }}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!--Nội dung bút phê-->
                                <div class="row">
                                  <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div class="card mb-3">
                                      <div
                                          class="p-3"
                                          style="border: 0.5px dotted #ccc; border-radius: 3px;"
                                      >
                                        <div class="row">
                                          <div class="col-12">
                                            <p class="mb-0 text-primary fw-medium">Nội dung bút phê</p>
                                            <div v-if="data.item.butPhe.noiDungButPhe" class="mb-1">
                                              <p
                                                  class="mb-0 text-black-2a"
                                                  :inner-html.prop="data.item.butPhe.noiDungButPhe"
                                                  style="text-align: justify;"
                                              >
                                              </p>
                                            </div>
                                            <div v-else>
                                              <div
                                                  class="mb-0 text-black-2a"
                                              >
                                                <div class="d-flex justify-content-start align-items-baseline">
                                                  <i class="fas fa-exclamation-circle me-2 text-danger"></i>
                                                  <p class="mb-0 text-danger">Không có nội dung bút phê.</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="card">
                                      <div
                                          class="p-3"
                                          style="border: 0.5px dotted #ccc; border-radius: 3px;"
                                      >
                                        <div class="row">
                                          <div class="col-12">
                                            <p class="mb-0 text-primary fw-medium mb-2">Thành phần tham gia</p>
                                            <div
                                                v-if="data.item.butPhe.nguoiChuTri"
                                                class="d-flex align-items-center mb-2"
                                            >
                                              <p class="mb-0 text-muted me-2">Người chủ trì</p>
                                              <p class="mb-1 bp-text-infor">{{
                                                  data.item.butPhe.nguoiChuTri.fullName
                                                }}</p>
                                            </div>
                                            <div
                                                v-if="data.item.butPhe.nguoiPhuTrach"
                                                class="d-flex align-items-center mb-2"
                                            >
                                              <p class="mb-0 text-muted me-2">Người phụ trách</p>
                                              <div
                                                  v-for="(items, index) in data.item.butPhe.nguoiPhuTrach"
                                                  :key="index"
                                              >
                                                <p class="mb-1 bp-text-infor me-2">{{ items.fullName }}</p>
                                              </div>
                                            </div>
                                            <div
                                                v-if="data.item.butPhe.nguoiPhoiHopXuLy"
                                                class="d-flex align-items-center mb-2"
                                            >
                                              <p class="mb-0 text-muted me-2">Người phối hợp xử lý</p>
                                              <div
                                                  v-for="(items, index) in data.item.butPhe.nguoiPhoiHopXuLy"
                                                  :key="index"
                                              >
                                                <p class="mb-1 bp-text-infor me-2">{{ items.fullName }}</p>
                                              </div>
                                            </div>
                                            <div
                                                v-if="data.item.butPhe.donViPhoiHop"
                                                class="d-flex align-items-center mb-2 flex-wrap"
                                            >
                                              <p class="mb-0 text-muted me-2">Đơn vị phối hợp</p>
                                              <div
                                                  v-for="(items, index) in data.item.butPhe.donViPhoiHop"
                                                  :key="index"
                                              >
                                                <p class="mb-1 bp-text-infor me-2">{{ items.ten }}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div class="card mb-3">
                                      <div
                                          class="p-3"
                                          style="border: 0.5px dotted #ccc; border-radius: 3px;"
                                      >
                                        <div class="d-flex justify-content-between align-items-center">
                                          <p class="mb-0 text-primary fw-medium">Báo cáo xử lý văn bản</p>
                                          <b-button
                                              v-if="isNguoiChuTri(data.item.butPhe.nguoiChuTri)"
                                              variant="primary"
                                              class="btn-primary px-3"
                                              size="sm"
                                              @click="handleSubmitXuLy(data.item)"
                                          >
                                            <i class="fas fa-save text-white me-1"></i>
                                            Lưu
                                          </b-button>
                                        </div>
                                        <div class="mb-2">

                                        </div>
                                        <div class="mb-2">
                                          <p class="mb-0 text-danger fw-medium">Chọn trạng thái</p>
                                          <div class="d-flex align-items-center">
                                            <div class="d-flex align-items-center me-2">
                                              <input
                                                  type="radio"
                                                  name="status"
                                                  class="me-2"
                                                  checked
                                                  v-model="noiDungXuLy.daXuLy"
                                                  value="true"
                                              >
                                              <p class="mb-0 text-dark">Đã hoàn thành</p>
                                            </div>
                                            <div class="d-flex align-items-center">
                                              <input
                                                  type="radio"
                                                  name="status"
                                                  class="me-2"
                                                  v-model="noiDungXuLy.daXuLy"
                                                  value="false"
                                              >
                                              <p class="mb-0 text-dark">Chưa hoàn thành</p>
                                            </div>
                                          </div>
                                        </div>
                                        <!--                            Ngày xử lý -->
                                        <div class="mb-2">
                                          <label class="form-label" for="validationCustom01">Ngày xử lý</label>
                                          <date-picker v-model="data.item.noiDungXuLy.ngayXuLy"
                                                       format="DD/MM/YYYY"
                                                       value-type="format"
                                          >
                                            <div slot="input">
                                              <input v-model="data.item.noiDungXuLy.ngayXuLy"
                                                     v-mask="'##/##/####'" type="text" class="form-control"
                                                     placeholder="Nhập ngày xử lý"/>
                                            </div>
                                          </date-picker>
                                        </div>
                                        <div class="mb-2">
                                          <div class="d-flex align-items-center mb-2">
                                            <i class="fas fa-pencil-alt me-2"></i>
                                            <p class="mb-0 text-primary">Nhập nội dung báo cáo</p>
                                          </div>
                                          <div class="ckeditor-classic">
                                            <ckeditor-nuxt v-model="data.item.noiDungXuLy.noiDung"
                                                           :config="editorConfig"/>
                                          </div>
                                        </div>
                                        <div v-if="data.item.noiDungXuLy.files" class="col-sm-12">
                                          <p class="mb-0 text-primary"><i class="mdi mdi-folder"></i> Văn bản đính kèm:
                                          </p>
                                          <div class="mb-1 d-flex file-box">
                                            <div
                                                v-for="(value, index) in data.item.noiDungXuLy.files" :key="index"
                                                class="mb-1 me-2"
                                                style="background-color: rgba(47,147,224,0.2); border-radius: 3px; padding: 5px;"
                                            >
                                              <a
                                                  :href="`${apiUrl}files/view/${value.fileId}`"
                                                  class=" fw-medium"
                                              ><i
                                                  class="fas fa-cloud-download-alt text-primary mx-2"
                                              ></i>
                                                [Tải về]
                                              </a>
                                              <a v-if="value.ext=='.pdf'" style="cursor: pointer"
                                                 @click="handleShowFile(value.fileId)"
                                                 class="text-danger fw-medium">
                                                [Xem]
                                              </a>
                                              <span
                                                  style="font-weight: 500; color: #2F93E0"
                                                  class="px-2"
                                              >
                                        {{ value.fileName }}
                                      </span>
                                              <button
                                                  type="button"
                                                  size="sm"
                                                  class="btn btn-outline btn-sm"
                                                  data-toggle="tooltip" data-placement="bottom" title="Xóa"
                                                  v-on:click="function(){
 if (data.item.noiDungXuLy && data.item.noiDungXuLy.files) {
          data.item.noiDungXuLy.files.splice(index, 1);
        }
                                                  }">
                                                <i class="fas fa-trash-alt text-danger me-1"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="mb-2">
                                          <div class="d-flex align-items-center mb-2">
                                            <i class="fas fa-link me-2"></i>
                                            <p class="mb-0 text-primary">File đính kèm</p>
                                          </div>
                                          <div>
                                            <vue-dropzone
                                                id="dropzone"
                                                ref="myVueDropzone"
                                                :use-custom-slot="true"
                                                :options="dropzoneOptions"
                                                v-on:vdropzone-removed-file="function (file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData =data.item.noiDungXuLy.files.filter(x => {
          return x.fileId != idFile;
        })
        data.item.noiDungXuLy.files = resultData;
      }
    }"
                                                v-on:vdropzone-success="function(file, response){
                                                  if(data.item.noiDungXuLy == null){
                                                    data.item.noiDungXuLy ={ daXuLy: false,
            noiDung: null,
            ngayXuLy: null,
            sysNgayXuLy: null,
            files: null}
                                                  }
      if (data.item.noiDungXuLy.files == null || data.item.noiDungXuLy.files.length <= 0) {
          data.item.noiDungXuLy.files = [];
        }
        let fileSuccess = response.data;
        data.item.noiDungXuLy.files.push({fileId: fileSuccess.id, fileName: fileSuccess.fileName, ext: fileSuccess.ext})
    }"
                                            >
                                              <div class="dropzone-custom-content">
                                                <i
                                                    class="display-1 text-muted bx bxs-cloud-upload"
                                                    style="font-size: 70px"
                                                ></i>
                                                <p style="font-size: 18px">
                                                  Kéo thả tệp tin hoặc bấm vào để tải tệp tin
                                                </p>
                                              </div>
                                            </vue-dropzone>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p class="mb-0">
                                Báo cáo đánh giá
                              </p>
                            </b-tab>
                          </b-tabs>
                        </b-card>
                      </b-collapse>

                    </template>
                  </b-table>
                  <template v-if="isBusy">
                    <div align="center"> <LetterCube></LetterCube></div>
                  </template>
                  <template v-if="totalRows <= 0 && !isBusy">
                    <div align="center">Không có dữ liệu</div>
                  </template>
                </div>
                <!-- Paginnation -->
                <!--                <div class="row">-->
                <!--                  <b-col>-->
                <!--                    <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>-->
                <!--                  </b-col>-->
                <!--                  <div class="col">-->
                <!--                    <div-->
                <!--                        class="dataTables_paginate paging_simple_numbers float-end">-->
                <!--                      <ul class="pagination pagination-rounded mb-0">-->
                <!--                        &lt;!&ndash; pagination &ndash;&gt;-->
                <!--                        <b-pagination-->
                <!--                            v-model="currentPage"-->
                <!--                            :total-rows="totalRows"-->
                <!--                            :per-page="perPage"-->
                <!--                        ></b-pagination>-->
                <!--                      </ul>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <div>
                  <div class="row mb-2">
                    <div class="col-sm-12 col-md-6">
                      <div style="display: flex; justify-content: start; align-items: center">
                        <div style="margin-right: 20px" class="">
                          <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                              Hiện
                              <b-form-select
                                  class="form-select form-select-sm"
                                  v-model="perPage"
                                  size="sm"
                                  :options="pageOptions"
                              ></b-form-select
                              >&nbsp;dòng
                            </label>
                          </div>

                        </div>
                        <div class="">
                          <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div
                          class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        Trạng thái -->
        <b-modal
            v-model="showTrangThaiModal"
            centered
            title="Xử lý văn bản"
            title-class="font-18"
            no-close-on-backdrop
            size="lg"
            ref="formContainerTrangThai"
        >
          <div class="row">
            <div class="col-md-6">

              <div v-if="modelTrangThai.currentTrangThai" class="mb-2">
                <label class="form-label" for="validationCustom01">Trạng thái hiện tại</label> <span
                  class="text-danger">*</span>
                <input
                    id="validationCustom01"
                    :value="modelTrangThai.currentTrangThai.ten"
                    type="text"
                    class="form-control"
                    placeholder=""
                    disabled
                />
              </div>

            </div>
            <div class="col-md-6">

              <div class="mb-2">
                <label class="form-label" for="validationCustom01">Trạng thái tiếp theo</label> <span
                  class="text-danger">*</span>
                <multiselect
                    v-model="modelTrangThai.newTrangThai"
                    :options="optionsTrangThai"
                    track-by="code"
                    label="ten"
                    placeholder="Chọn trạng thái"
                    deselect-label="Nhấn để xoá"
                    selectLabel="Nhấn enter để chọn"
                    selectedLabel="Đã chọn"
                    :class="{
                                'is-invalid':
                                  submitted && $v.modelTrangThai.newTrangThai.$error,
                                }"
                ></multiselect>
                <div
                    v-if="submitted && !$v.modelTrangThai.newTrangThai.required"
                    class="invalid-feedback"
                >
                  Trạng thái không được để trống.
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="modelTrangThai.newTrangThai && modelTrangThai.newTrangThai.code == 'BHVBD'">
            <div class="col-md-6">
              <div class="mb-2">
                <label class="form-label" for="validationCustom01"> Đơn vị ban hành</label>
                <treeselect :multiple="true"
                            v-model="modelTrangThai.donVi"
                            :options="optionsDonViTree" :searchable="true"
                            :value-consists-of="valueConsistsOf" :normalizer="normalizer" value-format="object">

                  <label slot="option-label"
                         slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                         :class="labelClassName">
                    {{ node.label }}
                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                  </label>
                </treeselect>
              </div>

            </div>
            <div class="col-md-6">
              <div class="mb-2">
                <label class="form-label" for="validationCustom01"> Người nhận thông báo</label>
                <multiselect
                    v-model="modelTrangThai.dSNguoiNhanThongBao"
                    :options="optionsUser"
                    track-by="id"
                    label="fullName"
                    placeholder="Chọn người nhận thông báo"
                    deselect-label="Nhấn để xoá"
                    selectLabel="Nhấn enter để chọn"
                    selectedLabel="Đã chọn"
                    :multiple="true"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.fullName }}</strong>

                    <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                  </template>
                  <template slot="option" slot-scope="{ option }">
                    <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                      <span v-if="option.donVi" class="option__small"
                            style="color:green">{{ option.donVi.ten }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
          <template #modal-footer>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      class="btn btn-outline-info w-md"
                      v-on:click="showTrangThaiModal = false">
              Đóng
            </b-button>
            <b-button v-if="modelTrangThai.newTrangThai && modelTrangThai.newTrangThai.code == 'tlddv'"
                      v-b-modal.modal-close_visit
                      size="sm"
                      variant="primary"
                      type="button"
                      class="w-md"
                      :disabled="modelTrangThai.lanhDaoDonVi == null"
                      v-on:click="handleChuyenTrangThaiVanBan(null)">
              Trình lãnh đạo đơn vị
            </b-button>
            <b-button
                v-if="modelTrangThai.newTrangThai && modelTrangThai.newTrangThai.code == 'PCVBD' && modelButPhe.noiDungButPhe == null  || modelButPhe.noiDungButPhe == ''"
                v-b-modal.modal-close_visit
                size="sm"
                variant="primary"
                type="button"
                class="w-md"
                @click="handleShowButPhe(model.id)"
            >
              Bút phê VBD
            </b-button>
            <b-button
                v-if="modelTrangThai.newTrangThai && modelTrangThai.newTrangThai.code == 'PCVBD' && modelButPhe.noiDungButPhe != null"
                v-b-modal.modal-close_visit
                size="sm"
                variant="primary"
                type="button"
                class="w-md"
                @click="HandleShowPhanCong(model.id)"
            >
              Phân công VBD
            </b-button>
            <b-button v-else v-b-modal.modal-close_visit
                      size="sm"
                      variant="primary"
                      type="button"
                      class="w-md"
                      v-on:click="handleChuyenTrangThaiVanBan(null)">
              Chuyển trạng thái
            </b-button>
          </template>
        </b-modal>
        <!--        modal tran thai van ban -->
        <b-modal
            v-model="showCheckVanBanModal"
            centered
            title="Chi tiết VB"
            title-class="font-18"
            no-close-on-backdrop
            size="lg"
            ref="refshowCheckVanBanModal"
            hide-footer
        >
          <div class="row" style="width: 100%; margin: 0">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12 capso-container">
                  <div class="title-capso">Số lưu VB</div>
                  <div class="content-capso">{{ model.soLuuCV }}</div>
                </div>
                <div class="col-md-12 capso-container">
                  <div class="title-capso"> Ngày nhập công văn</div>
                  <div class="content-capso">{{ model.ngayNhap }}</div>
                </div>

                <div class="col-md-12 capso-container">
                  <div class="title-capso"> Ngày ký</div>
                  <div class="content-capso">{{ model.ngayKy }}</div>
                </div>
                <div class="col-md-12 capso-container">
                  <div class="title-capso"> Trích yếu</div>
                  <div class="content-capso">
                    <div v-if="model.trichYeu" :inner-html.prop="model.trichYeu | truncate(150)">
                    </div>
                  </div>
                  <!--                <div class="col-md-12 capso-container">-->
                  <!--                  <div class="title-capso"> Ngày ký</div>-->
                  <!--                  <div class="content-capso">{{model.ngayKy}}</div>-->
                  <!--                </div>-->
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12 capso-container">
                  <div class="title-capso"> Loại văn bản</div>
                  <template v-if="model.loaiVanBan">
                    <div class="content-capso">{{ model.loaiVanBan.ten }}</div>
                  </template>
                </div>
                <div class="col-md-12 capso-container">
                  <div class="title-capso"> Trạng thái</div>
                  <template v-if="model.trangThai">
                    <div class="content-capso">{{ model.trangThai.ten }}</div>
                  </template>
                </div>

              </div>

            </div>
            <div class="col-md-12" style="padding: 0px">
              <h5 style="font-weight: bold">Duyệt thể thức văn bản</h5>
              <div class="col-md-12 capso-container" style="display: flex; flex-direction: column">
                <div class="title-capso">Tện tin dính kèm của người soạn</div>
                <ul v-if="model.file && model.file.length > 0" style="padding-left: 30px">
                  <li class="title-capso" style="font-weight: normal" v-for="(value, index) in model.file" :key="index">

                    <a
                        :href="`${apiUrl}files/view/${value.fileId}`"
                        class=" fw-medium"
                    ><i
                        :class="`mdi font-size-16 align-middle me-2`"
                    ></i>
                      [Tải về]</a
                    >
                    <span style="padding-left: 20px">{{ value.fileName }}</span>
                  </li>
                </ul>

              </div>
              <div class="mb-3">
                <label class="form-label title-capso">Lý do từ chối</label>
                <div>
                  <textarea
                      v-model="modelTrangThai.noiDung"
                      class="form-control"
                      name="textarea"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <template #modal-header="{  }">
            <!-- Emulate built in modal header close button action -->
            <h5 style="min-width: 200px"> Văn bản đến</h5>
            <div style="width: 100%; display: flex; justify-content: flex-end" class="text-end">
              <div v-if="optionsTrangThai && optionsTrangThai.length" style="display: flex">
                <div v-for="(value, index) in optionsTrangThai" :key="index">

                  <b-button type="button" :class="'btn-' + value.bgColor" class="ms-1" style="min-width: 80px;"
                            size="sm"
                            @click="handleChuyenTrangThaiVanBan(value)"
                  >
                    {{ value.ten }}
                  </b-button>
                </div>

              </div>

              <b-button variant="light" class="ms-1" size="sm" style="width: 80px"
                        @click="showCheckVanBanModal = false">
                Đóng
              </b-button>
            </div>
          </template>
        </b-modal>
        <!--        Modal bút phê-->
        <b-modal
            v-model="showModalButPhe"
            body-class="p-3"
            hide-footer
            centered
            no-close-on-backdrop
            size="xl"
        >
          <template #modal-header="{ }">
            <h5 class="text-black font-size-16 fw-bold">Bút phê đơn vị lãnh đạo, đơn vị nhận/ xử lý văn bản</h5>
            <div class="text-end">
              <b-button variant="light" class="w-md" size="sm"
                        @click="showModalButPhe = false"
              >
                Đóng
              </b-button>
              <b-button type="submit" variant="primary" size="sm" class="ms-1 w-md"
                        @click="handleButPhe"
              >
                Lưu
              </b-button>
            </div>
          </template>
          <form @submit.prevent="handleButPhe" ref="formContainer">
            <div class="row">
              <div class="col-md-6">
                <!--                Số lưu and số văn bản đến -->
                <div class="d-flex justify-content-start">
                  <!--                              Số lưu -->
                  <div class="me-4 d-flex align-items-baseline">
                    <label class="form-label me-2" for="validationCustom01">Số lưu VB:</label>
                    <p class="fw-bold text-primary">{{ model.soLuuCV }}</p>
                  </div>
                  <!--                            Số VB đến -->
                  <div class="d-flex align-items-baseline">
                    <label class="form-label me-2" for="validationCustom01">Số văn bản đến:</label>
                    <p class="fw-bold text-primary">{{ model.soVBDen }}</p>
                  </div>
                </div>
                <!--                Trích yếu -->
                <div class="mb-2">
                  <label class="form-label" for="validationCustom01">Trích yếu</label>
                  <div
                      :inner-html.prop="model.trichYeu | truncate(100)"
                      class="bg-soft-blue-grey p-2"
                      style="border-radius: 3px; color: #2a2a2a;"
                  ></div>
                </div>
                <!--                Bút phê -->
                <label class="form-label" for="validationCustom01">Bút phê</label> <span
                  class="text-danger">*</span>
                <ckeditor-nuxt v-if="modelButPhe" v-model="modelButPhe.noiDungButPhe" :config="editorConfig"/>
                <!--                Lãnh đạo bút phê -->
                <div class="mb-2">
                  <label class="form-label" for="validationCustom01">Lãnh đạo bút phê</label>
                         <multiselect
                             v-model="modelButPhe.nguoiButPhe"
                    :options="optionsUser"
                    track-by="id"
                    label="fullName"
                             placeholder="Chọn lãnh đạp bút phê"
                             deselect-label="Nhấn để xoá"
                             selectLabel="Nhấn enter để chọn"
                             selectedLabel="Đã chọn"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.fullName }}</strong>

                    <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                  </template>
                  <template slot="option" slot-scope="{ option }">
                    <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                      <span v-if="option.donVi" class="option__small"
                            style="color:green">{{ option.donVi.ten }}</span>
                    </div>
                  </template>
                </multiselect>
                </div>
                <!--                Ngày bút phê -->
                <div class="mb-2">
                  <label class="form-label" for="validationCustom01">Ngày bút phê</label>
                  <date-picker v-model="modelButPhe.ngayButPhe"
                               format="DD/MM/YYYY"
                               value-type="format"
                  >
                    <div slot="input">
                      <input v-model="modelButPhe.ngayButPhe"
                             v-mask="'##/##/####'" type="text" class="form-control" placeholder="Chọn ngày bút phê"/>
                    </div>
                  </date-picker>
                </div>
              </div>
              <div class="col-md-6">
                <!--                Mức độ quan trong -->
                <div class="mb-2">
                  <label class="form-label" for="validationCustom01">Mức độ quan trọng</label>
                  <multiselect
                      v-model="modelButPhe.mucDoQuanTrong"
                      :options="optionsMucDo"
                      track-by="id"
                      label="name"
                      placeholder="Chọn mức độ quan trọng"
                      deselect-label="Nhấn để xoá"
                      selectLabel="Nhấn enter để chọn"
                      selectedLabel="Đã chọn"
                  ></multiselect>
                </div>
                <!--                Ngừoi chủ trì -->
                <div class="mb-2">
                  <label class="form-label" for="validationCustom01">Người chủ trì</label>
                  <multiselect
                      v-model="modelButPhe.nguoiChuTri"
                      :options="optionsUser"
                      track-by="id"
                      label="fullName"
                      placeholder=""
                      deselect-label="Nhấn để xoá"
                      selectLabel="Nhấn enter để chọn"
                      selectedLabel="Đã chọn"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.fullName }}</strong>

                      <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                        <span v-if="option.donVi" class="option__small"
                              style="color:green">{{ option.donVi.ten }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
                <!--                Người phụ trách -->
                <div class="mb-2">
                  <label class="form-label" for="validationCustom01">Người phụ trách</label>
                  <multiselect
                      :multiple="true"
                      v-model="modelButPhe.nguoiPhuTrach"
                      :options="optionsUser"
                      track-by="id"
                      label="fullName"
                      placeholder=""
                      deselect-label="Nhấn để xoá"
                      selectLabel="Nhấn enter để chọn"
                      selectedLabel="Đã chọn"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.fullName }}</strong>

                      <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                        <span v-if="option.donVi" class="option__small"
                              style="color:green">{{ option.donVi.ten }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>

                <!--                Người phối hợp xử lý-->
                <div class="mb-2">
                  <label class="form-label" for="validationCustom01">Người phối hợp xử lý</label>
                  <multiselect
                      :multiple="true"
                      v-model="modelButPhe.nguoiPhoiHopXuLy"
                      :options="optionsUser"
                      track-by="id"
                      label="fullName"
                      placeholder=""
                      deselect-label="Nhấn để xoá"
                      selectLabel="Nhấn enter để chọn"
                      selectedLabel="Đã chọn"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.fullName }}</strong>

                      <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                        <span v-if="option.donVi" class="option__small"
                              style="color:green">{{ option.donVi.ten }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
                <!--                Đơn vị xử lý-->
                <div class="mb-2">
                  <!--                  <label class="form-label" for="validationCustom01">Đơn vị xử Lý</label>-->
                  <!--                  <treeselect-->
                  <!--                      :multiple="true"-->
                  <!--                      v-model="modelButPhe.donViXuLy"-->
                  <!--                      :options="optionsDonVi"-->
                  <!--                      placeholder="Chọn đơn vị xử lý"-->
                  <!--                      value-format="object"-->
                  <!--                  />-->
                  <!--                  <treeselect-value :value="model.donViXuLy"/>-->
                  <!--                  <treeselect-->
                  <!--                      v-on:select="formatDonViXuLy"-->
                  <!--                      v-on:deselect="formatRemoveDonViXuLy"-->
                  <!--                      :options="optionsDonVi"-->
                  <!--                      :value="modelButPhe.donViPhoiHop"-->
                  <!--                      :searchable="true"-->
                  <!--                      :show-count="true"-->
                  <!--                      :default-expand-level="1"-->
                  <!--                      :normalizer="normalizer"-->
                  <!--                      value-format="object"-->
                  <!--                  >-->

                  <!--                    <label slot="option-label"-->
                  <!--                           slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"-->
                  <!--                           :class="labelClassName">-->
                  <!--                      {{ node.label }}-->
                  <!--                      <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>-->
                  <!--                    </label>-->
                  <!--                  </treeselect>-->
                </div>
                <!--                Đơn vị phối hợp-->
                <div class="mb-2">
                  <label class="form-label" for="validationCustom01"> Đơn vị phối hợp</label>
                  <treeselect
                      v-on:select="formatDonVi"
                      v-on:deselect="formatRemoveDonVi"
                      :multiple="true"
                      :options="optionsTreeDonVi"
                      :value="modelButPhe.donViPhoiHop"
                      :searchable="true"
                      :show-count="true"
                      :default-expand-level="1"
                      :normalizer="normalizer"
                      value-format="object"
                      placeholder="Chọn đơn vị phối hợp"
                  >

                    <label slot="option-label"
                           slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                           :class="labelClassName">
                      {{ node.label }}
                      <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                    </label>
                  </treeselect>
                </div>
                <!--                Ngừoi xem để biết-->
                <div class="mb-2">
                  <label class="form-label" for="validationCustom01">Người xem để biết</label>
                  <multiselect
                      :multiple="true"
                      v-model="modelButPhe.nguoiXemDeBiet"
                      :options="optionsUser"
                      track-by="id"
                      label="fullName"
                      placeholder=""
                      deselect-label="Nhấn để xoá"
                      selectLabel="Nhấn enter để chọn"
                      selectedLabel="Đã chọn"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.fullName }}</strong>

                      <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                        <span v-if="option.donVi" class="option__small"
                              style="color:green">{{ option.donVi.ten }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="col-md-12">
                <!--                File đính kèm-->
                <div class="mb-2">
                  <label for="">File đính kèm</label>
                  <div>
                    <vue-dropzone
                        id="dropzone"
                        ref="myVueDropzone"
                        :options="dropzoneOptions"
                        :use-custom-slot="true"
                        v-on:vdropzone-removed-file="removeThisFile"
                        v-on:vdropzone-success="addThisFile"
                    >
                      <div class="dropzone-custom-content">
                        <i
                            class="display-1 text-muted bx bxs-cloud-upload"
                            style="font-size: 70px"
                        ></i>
                        <p style="font-size: 18px">
                          Kéo thả tệp tin hoặc bấm vào để tải tệp tin
                        </p>
                      </div>
                    </vue-dropzone>
                  </div>

                </div>
              </div>
            </div>

          </form>
        </b-modal>
        <!--        Modal phân công -->
        <b-modal
            v-model="showModalPhanCong"
            title="Phân công xử lý"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
            centered
            no-close-on-backdrop
            size="xl"
        >
          <form @submit.prevent="handlePhanCong" ref="formContainer">
            <div class="row">
              <div class="col-md-12">
                <div class="customAddElement">
                  <b-button
                      pill
                      variant="success"
                      @click="AddformData(modelPhanCong.vanBanDenId)"
                  >
                    <i class="fas fa-plus text-light fs-3"></i>
                  </b-button>
                </div>
                <div class="mb-4"></div>
                <div data-repeater-list="group-a">
                  <div
                      v-for="(items, index) in phanCong"
                      :key="items.id"
                      class="card mx-3"
                  >
                    <div class="card-body" style="position: relative">
                      <div class="custom-ribon">
                        <div class="bg-primary text-center">
                          <p class="text-light p-1">Nhóm {{ index }}</p>
                        </div>
                      </div>
                      <div class="row align-items-center">
                        <div class="col-lg-12 d-flex justify-content-end">
                          <b-button
                              pill
                              @click="deleteRow(index)"
                          >
                            <i class="fas fa-trash text-danger"></i>
                          </b-button>
                        </div>
                        <div class="col-md-12 mb-2">
                          <label class="form-label" for="validationCustom01">Ý kiến chỉ đạo</label> <span
                            class="text-danger">*</span>
                          <ckeditor-nuxt v-model="items.yKienChiDao" :config="editorConfig"/>
                        </div>
                        <div class="col-md-5 mb-3">
                          <div class="mb-2">
                            <label class="form-label" for="validationCustom01">Người bút phê</label>
                            <multiselect
                                v-model="items.nguoiButPhe"
                                :options="optionsUser"
                                track-by="id"
                                label="fullName"
                                placeholder="Chọn người bút phê"
                                deselect-label="Nhấn để xoá"
                                selectLabel="Nhấn enter để chọn"
                                selectedLabel="Đã chọn"
                            ></multiselect>
                          </div>
                        </div>
                        <div class="col-md-2 mb-3 text-center">
                          <div class="d-flex align-items-center justify-content-center ">
                            <i class="fas fa-folder-open text-lime fs-2 me-1"></i>
                            <i class="fas fa-chevron-right text-secondary "></i>
                            <i class="fas fa-chevron-right text-lime"></i>
                          </div>

                        </div>
                        <div class="col-md-5 mb-3">
                          <div class="mb-2">
                            <label class="form-label" for="validationCustom01">Người nhận</label>
                            <multiselect
                                :multiple="true"
                                v-model="items.nguoiNhanXuLy"
                                :options="optionsUser"
                                track-by="id"
                                label="fullName"
                                placeholder="Chọn người nhận xử lý"
                                deselect-label="Nhấn để xoá"
                                selectLabel="Nhấn enter để chọn"
                                selectedLabel="Đã chọn"
                            ></multiselect>
                          </div>
                        </div>
                        <!--                        <div class="col-md-12">-->
                        <!--                          <div class="mb-2">-->
                        <!--                            <label for="">File đính kèm</label>-->
                        <!--                            <vue-dropzone-->
                        <!--                                id="dropzone"-->
                        <!--                                ref="myVueDropzone"-->
                        <!--                                :options="dropzoneOptions"-->
                        <!--                                v-on:vdropzone-removed-file="removeThisFile"-->
                        <!--                                v-on:vdropzone-success="addThisFile"-->
                        <!--                            ></vue-dropzone>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="text-end pt-2 mt-3">
              <b-button variant="light" class="w-md" size="sm" @click="showModalPhanCong = false">
                Đóng
              </b-button>
              <b-button type="submit" variant="primary" size="sm" class="ms-1 w-md">
                Lưu
              </b-button>
            </div>
          </form>
        </b-modal>
        <!--        Modal delete -->
        <b-modal
            v-model="showDeleteModal"
            centered
            title="Xóa dữ liệu"
            title-class="font-18"
            no-close-on-backdrop
        >
          <p>
            Dữ liệu xóa sẽ không được phục hồi!
          </p>
          <template #modal-footer>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      class="btn btn-outline-info w-md"
                      v-on:click="showDeleteModal = false">
              Đóng
            </b-button>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      variant="danger"
                      type="button"
                      class="w-md"
                      v-on:click="handleDelete">
              Xóa
            </b-button>
          </template>
        </b-modal>

        <!--        history-->
        <b-modal
            v-model="showHistoryModal"
            centered
            title="Lịch sử hoạt động"
            title-class="fw-bold fs-5 text-dark"
            no-close-on-backdrop
            size="lg"
            hide-footer
        >

          <div class="table-responsive-sm table-responsive">
            <b-table
                class="datatables"
                :items="listHistoryQuestion"
                :fields="fieldsHistory"
                striped
                bordered
                responsive="sm"
                :per-page="pageOptionsHistory"
                :current-page="currentPageHistory"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                ref="tblList"
                primary-key="id"
                :busy.sync="isBusy"
            >
              <template v-slot:cell(STT)="data">
                {{ data.index + ((currentPageHistory - 1) * perPageHistory) + 1 }}
              </template>
              <template v-slot:cell(trangThai)="data">
                <div @click="handleDetailHistory(data.item.id)" style="cursor: pointer">
                          <span v-if="data.item.trangThai" class="badge px-2 py-1"
                                :class="'bg-' + data.item.trangThai.bgColor">
                            {{ data.item.trangThai.ten }}
                          </span>
                </div>
              </template>
              <template v-slot:cell(userName)="data">
                <div>
                          <span>
                            {{ data.item.userName }} - {{ data.item.fullName }}
                          </span>
                </div>
              </template>
              <template v-slot:cell(createdAt)="data">
                <div>
                          <span>
                            {{ data.item.createdAt }} - {{ data.item.createdAtTimeShow }}
                          </span>
                </div>
              </template>

            </b-table>
            <template v-if="isBusy">
              <div align="center">
                <LetterCube></LetterCube>
              </div>
            </template>
            <template v-if="listHistoryQuestion.length <= 0 && !isBusy">
              <div align="center">Không có dữ liệu</div>
            </template>
          </div>
          <!-- Paginnation -->
          <div>
            <div class="row mb-2">
              <div class="col-sm-12 col-md-6">
                <div style="display: flex; justify-content: start; align-items: center">
                  <div id="tickets-table_length" class="dataTables_length me-4">
                    <label class="d-inline-flex align-items-center">
                      Hiện
                      <b-form-select
                          class="form-select form-select-sm"
                          v-model="perPageHistory"
                          size="sm"
                          :options="pageOptionsHistory"
                      ></b-form-select
                      >&nbsp;dòng
                    </label>
                  </div>
                  <div>Hiển thị {{ numberOfElementHistory }} trên tổng số {{ totalRowsHistory }} dòng</div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPageHistory"
                        :total-rows="totalRowsHistory"
                        :per-page="perPageHistory"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
          <!--          <template #modal-footer>-->
          <!--            <b-button v-b-modal.modal-close_visit-->
          <!--                      size="sm"-->
          <!--                      class="btn btn-outline-info w-md"-->
          <!--                      v-on:click="showHistoryModal = false">-->
          <!--              Đóng-->
          <!--            </b-button>-->
          <!--          </template>-->
        </b-modal>
        <!--        modal history detail-->
        <b-modal
            v-model="showModalDetailHistory"
            centered
            title="Chi tiết trạng thái"
            title-class="fw-bold fs-5 text-dark"
            no-close-on-backdrop
            size="lg"
            hide-footer
        >
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="d-flex justify-content-between mb-1">
                <p class="mb-0 text-primary">Nội dung:</p>
                <p class="mb-0 fw-medium text-black-2a"> Test detail history</p>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <p class="mb-0 text-primary">Trạng thái:</p>
                <!--                <p-->
                <!--                    class="mb-0 fw-medium text-white px-2"-->
                <!--                    :class="'bg-' + data.item.trangThai.bgColor"-->
                <!--                    style="border-radius: 3px;"-->
                <!--                > {{ data.item.trangThai.ten }}</p>-->
                <p class="mb-0 fw-medium text-black-2a"> Test detail</p>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<style>
.td-stt {
  text-align: center;
  width: 50px;
}

.td-xuly {
  text-align: center;
  width: 130px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

.ck-editor__editable {
  min-height: 100px !important;
}

.ck-content {
  height: 100px !important;
}

.customAddElement {
  position: absolute;
  top: 8px;
  left: -20px;
}

.custom-ribon {
  position: absolute;
  width: 130px;
  top: 15px;
  left: -15px;
}

.custom-ribon > div {
  border-radius: 3px;
}

.title-capso {
  font-weight: bold;
  color: #00568C;

}

.content-capso {
  padding: 5px;
  color: #00568C;
}

.capso-container {
  margin-top: 10px;
  display: flex;
  padding: 0px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

.show-detail-vbd {
  background-color: #e6f0fb;
  border: 1px solid #e6f0fb;
  border-radius: 7px;
  margin: 10px;
}

@media only screen and (max-width: 768px) {
  .show-detail-vbd {
    margin: 0px;
  }
}

.show-detail-vbd .card-body {
  padding: 0;

}

.show-detail-vbd .card-body .nav-tabs .nav-link {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border: none;
  background: transparent;
  color: #055E8F;
  border-radius: 5px;
}

.show-detail-vbd .card-body .nav-tabs .nav-link.active {
  background: #055E8F;
  color: #fff;
}

.show-detail-vbd .card-body .nav-tabs {
  border-bottom: none;
}


.text-black-2a {
  color: #2a2a2a;
}

.text-black {
  color: #000;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

.file-box {
  justify-content: start;
}

.bp-text-infor {
  background-color: rgba(5, 94, 143, 0.1);
  color: #055E8F;
  width: fit-content;
  padding: 0px 10px;
  border-radius: 3px;
}

.bp-text-success {
  background-color: rgba(2, 164, 153, 0.1);
  color: #02a499;
  width: fit-content;
  padding: 0px 10px;
  border-radius: 3px;
}

.bp-text-warning {
  background-color: rgba(248, 180, 37, 0.1);
  color: #f8b425;
  width: fit-content;
  padding: 0px 10px;
  border-radius: 3px;
}

.bp-text-danger {
  background-color: rgba(236, 69, 97, 0.1);
  color: #ec4561;
  width: fit-content;
  padding: 0px 10px;
  border-radius: 3px;
}

@media only screen and (max-width: 768px) {

  /* Force table to not be like tables anymore */
  .b-table-vbden .btn-process {
    padding: 0px !important;
  }

  .cs-table-xulyvbd table,
  .cs-table-xulyvbd thead,
  .cs-table-xulyvbd tbody,
  .cs-table-xulyvbd th,
  .cs-table-xulyvbd td,
  .cs-table-xulyvbd tr {
    display: block;
    padding: 5px 0px !important;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .cs-table-xulyvbd thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .cs-table-xulyvbd tr {
    border: 1px solid #f5f5f5;
    margin-bottom: 5px;
  }

  .cs-table-xulyvbd .table-bordered > :not(caption) > * {
    border-width: 0.5px;
    border-radius: 5px;
  }

  .cs-table-xulyvbd .table-bordered {
    border: none;
  }

  .cs-table-xulyvbd .table-bordered th:first-child,
  .cs-table-xulyvbd .table-bordered td:first-child {
    border-top: none;
  }

  .cs-table-xulyvbd .table-bordered th,
  .cs-table-xulyvbd .table-bordered td {
    border: none;
    border-top: 1px solid #f5f5f5;
  }

  .b-table-vbden > td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    min-height: 30px !important;
    padding-left: 20% !important;
    padding: 5px 0px;
  }

  .b-table-details.b-table-vbden > td {
    padding-left: 0% !important;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 5px;
    left: 6px;
    padding-right: 10px;
    white-space: nowrap;
  }


  .btn-process .btn {
    background-color: rgb(0 89 144 / 0.1);
    width: 20%;
    margin: 5px;
  }

  .file-box {
    flex-direction: column;
  }

  /*
  Label the data
  */
  .b-table-vbden > td:nth-of-type(1):before {
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(2):before {
    content: "Số Lưu VB";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(3):before {
    content: "Trích yếu";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(4):before {
    content: "Loại văn bản";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(5):before {
    content: "Trạng thái";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(6):before {
    content: "Hạn xử lý";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(7):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbden > td:nth-of-type(8):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }
}

@media only screen and (max-width: 425px) {
  .b-table-vbden > td {
    padding-left: 95px !important;
  }
}

.cs-close-tabs {
  position: relative;
}

.item-close-tabs {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-close-tabs:hover {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  width: 30px;
  height: 30px;
}

.item-icon {
  transform: rotate(135deg);
  color: #fff;
  width: 24px;
  height: 26px;
  position: absolute;
  top: 1px;
  right: -1px;
}

.multiselect {
  min-height: 34px;
}

.multiselect__select {
  height: 34px;
}

</style>

<style>
.multiselect {
  min-height: 34px;
}

.multiselect__select {
  height: 34px;
}
</style>
